import { Link } from 'react-router-dom';
import { ArrowLeft, Clock3, HardHat } from 'lucide-react';
import BrandLogo from '../components/BrandLogo';
import SEOHead from '../components/SEOHead';
import { Button } from '../components/ui/button';

export default function SuppliersComingSoonPage() {
  return (
    <div className="min-h-screen bg-[#F6F1EF] text-[#1C1C1C]">
      <SEOHead
        title="Fornecedores | Em construção"
        description="A área de fornecedores do Virei Noiva está em construção."
        noindex
      />

      <header className="border-b border-[#E8B7B1]/35 bg-[#F6F1EF]/90 backdrop-blur-md">
        <div className="container-wedding flex h-[5.25rem] items-center justify-between gap-4">
          <Link to="/" className="inline-flex items-center transition-opacity hover:opacity-95">
            <BrandLogo size="lg" showTagline />
          </Link>

          <Link to="/">
            <Button
              variant="outline"
              className="h-11 rounded-full border-[#E8B7B1] bg-white px-6 text-sm text-[#E8B7B1] hover:bg-[#F6F1EF]"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Voltar para a home
            </Button>
          </Link>
        </div>
      </header>

      <main className="container-wedding flex min-h-[calc(100vh-84px)] items-center justify-center py-16">
        <section className="mx-auto max-w-3xl rounded-[2rem] border border-[#E8B7B1]/35 bg-white p-8 text-center shadow-[0_24px_60px_-34px_rgba(28,28,28,0.32)] md:p-12">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#F6F1EF] text-[#C8A97E]">
            <HardHat className="h-8 w-8" />
          </div>

          <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#E8B7B1]/30 bg-[#FDF9F7] px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#C8A97E]">
            <Clock3 className="h-3.5 w-3.5" />
            Página em construção
          </p>

          <h1 className="mt-6 text-4xl leading-tight md:text-5xl" style={{ fontFamily: 'Playfair Display, serif' }}>
            A vitrine de fornecedores ainda está sendo preparada
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-[#4B4340]">
            Estamos organizando essa experiência para lançar da forma certa. Em breve, você vai poder explorar os fornecedores com uma navegação completa e mais refinada.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to="/">
              <Button className="h-11 rounded-full bg-[#E8B7B1] px-6 text-sm font-semibold text-white hover:bg-[#DDA39D]">
                Voltar para o início
              </Button>
            </Link>
            <Link to="/fornecedor/cadastro">
              <Button
                variant="outline"
                className="h-11 rounded-full border-[#E8B7B1] bg-white px-6 text-sm text-[#E8B7B1] hover:bg-[#F6F1EF]"
              >
                Trabalha com casamentos?
              </Button>
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}
